// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard.css */
.dashboard {
    color: #fff;
    background: linear-gradient(to right, #0f0c29, #302b63, #24243e);
    font-family: 'Orbitron', sans-serif; /* Replace with your preferred digital font */
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.dashboard-header {
    margin-bottom: 40px;
}

.dashboard-content {
    width: 100%;
    max-width: 1200px; /* Adjust as needed */
    display: flex;
    flex-direction: column;
    align-items: center;
}

.section-row {
    display: flex;
    justify-content: space-around;
    width: 100%;
    gap: 20px;
    flex-wrap: wrap; /* Allow wrapping on smaller screens */
}

.section {
    flex-basis: calc(33.333% - 20px); /* Subtract the total margin from the width */
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    justify-content: center;
}

.section-title {
    background-color: #222;
    color: #4bf542; /* Digital green */
    padding: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 1rem;
    width: calc(100% - 20px); /* Adjusted width to account for padding */
    text-align: center;
    margin-bottom: -1px; /* Adjusted to align with the top border of the box */
    box-sizing: border-box; /* Ensure padding is included in width calculation */
}

.stat-box {
    flex-grow: 1;
}

.stat-box, .tasks-list, .daily-reward-section {
    background: rgba(255, 255, 255, 0.1);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    padding: 20px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    width: 100%;
    box-sizing: border-box;
    margin-top: -10px; /* Align with the section title */
}

.stat-value {
    font-size: 1.5rem;
    color: #4bf542; /* Digital green */
    font-family: 'Digital-7', monospace; /* Replace with your preferred digital font */
}

.daily-reward-section, .tasks-section {
    width: 80%;
    max-width: 600px; /* Adjust based on your layout */
    margin-bottom: 20px;
}

.daily-reward-section .btn-claim, .tasks-section .btn-claim {
    margin-top: 10px;
    width: 100%; /* Ensure button width spans the container */
}

.task-item {
    background: rgba(0, 0, 0, 0.5);
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 10px;
    width: 100%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
}

.btn-claim {
    background-color: #e94560;
    color: #fff;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color 0.3s;
    width: 50%;
    align-self: center;
}

.btn-claim:hover {
    background-color: #f05454;
}

.btn-claim:disabled {
    background-color: #a9a9a9;
}

.modal {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    animation: fadeIn 0.5s;
}

.modal-content {
    background-color: #333;
    padding: 20px;
    border-radius: 15px;
    width: 50%;
    max-width: 450px;
    animation: scaleIn 0.3s;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
}

.close:hover,
.close:focus {
    color: #ddd;
    text-decoration: none;
    cursor: pointer;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes scaleIn {
    from { transform: scale(0.7); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
}

/* Responsive Design */
@media (max-width: 768px) {
    .section-row {
        flex-direction: column;
    }

    .section {
        width: 80%;
    }

    .section-title, .stat-box {
        width: 100%;
    }

    .daily-reward-section .btn-claim, .tasks-section .btn-claim {
        width: 100%; /* Set button width to fill container */
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/Dashboard.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,WAAW;IACX,gEAAgE;IAChE,mCAAmC,EAAE,6CAA6C;IAClF,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB,EAAE,qBAAqB;IACxC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,SAAS;IACT,eAAe,EAAE,sCAAsC;AAC3D;;AAEA;IACI,gCAAgC,EAAE,6CAA6C;IAC/E,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,cAAc,EAAE,kBAAkB;IAClC,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;IACf,wBAAwB,EAAE,0CAA0C;IACpE,kBAAkB;IAClB,mBAAmB,EAAE,qDAAqD;IAC1E,sBAAsB,EAAE,oDAAoD;AAChF;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,sBAAsB;IACtB,iBAAiB,EAAE,iCAAiC;AACxD;;AAEA;IACI,iBAAiB;IACjB,cAAc,EAAE,kBAAkB;IAClC,mCAAmC,EAAE,6CAA6C;AACtF;;AAEA;IACI,UAAU;IACV,gBAAgB,EAAE,gCAAgC;IAClD,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW,EAAE,4CAA4C;AAC7D;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,OAAO,qBAAqB,EAAE,UAAU,EAAE;IAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW,EAAE,uCAAuC;IACxD;AACJ","sourcesContent":["/* Dashboard.css */\n.dashboard {\n    color: #fff;\n    background: linear-gradient(to right, #0f0c29, #302b63, #24243e);\n    font-family: 'Orbitron', sans-serif; /* Replace with your preferred digital font */\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.dashboard-header {\n    margin-bottom: 40px;\n}\n\n.dashboard-content {\n    width: 100%;\n    max-width: 1200px; /* Adjust as needed */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.section-row {\n    display: flex;\n    justify-content: space-around;\n    width: 100%;\n    gap: 20px;\n    flex-wrap: wrap; /* Allow wrapping on smaller screens */\n}\n\n.section {\n    flex-basis: calc(33.333% - 20px); /* Subtract the total margin from the width */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 20px;\n    justify-content: center;\n}\n\n.section-title {\n    background-color: #222;\n    color: #4bf542; /* Digital green */\n    padding: 10px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    font-size: 1rem;\n    width: calc(100% - 20px); /* Adjusted width to account for padding */\n    text-align: center;\n    margin-bottom: -1px; /* Adjusted to align with the top border of the box */\n    box-sizing: border-box; /* Ensure padding is included in width calculation */\n}\n\n.stat-box {\n    flex-grow: 1;\n}\n\n.stat-box, .tasks-list, .daily-reward-section {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    padding: 20px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: -10px; /* Align with the section title */\n}\n\n.stat-value {\n    font-size: 1.5rem;\n    color: #4bf542; /* Digital green */\n    font-family: 'Digital-7', monospace; /* Replace with your preferred digital font */\n}\n\n.daily-reward-section, .tasks-section {\n    width: 80%;\n    max-width: 600px; /* Adjust based on your layout */\n    margin-bottom: 20px;\n}\n\n.daily-reward-section .btn-claim, .tasks-section .btn-claim {\n    margin-top: 10px;\n    width: 100%; /* Ensure button width spans the container */\n}\n\n.task-item {\n    background: rgba(0, 0, 0, 0.5);\n    padding: 15px;\n    border-radius: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n}\n\n.btn-claim {\n    background-color: #e94560;\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    border-radius: 5px;\n    transition: background-color 0.3s;\n    width: 50%;\n    align-self: center;\n}\n\n.btn-claim:hover {\n    background-color: #f05454;\n}\n\n.btn-claim:disabled {\n    background-color: #a9a9a9;\n}\n\n.modal {\n    position: fixed;\n    z-index: 1000;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    animation: fadeIn 0.5s;\n}\n\n.modal-content {\n    background-color: #333;\n    padding: 20px;\n    border-radius: 15px;\n    width: 50%;\n    max-width: 450px;\n    animation: scaleIn 0.3s;\n}\n\n.close {\n    color: #aaa;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.close:hover,\n.close:focus {\n    color: #ddd;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes scaleIn {\n    from { transform: scale(0.7); opacity: 0; }\n    to { transform: scale(1); opacity: 1; }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .section-row {\n        flex-direction: column;\n    }\n\n    .section {\n        width: 80%;\n    }\n\n    .section-title, .stat-box {\n        width: 100%;\n    }\n\n    .daily-reward-section .btn-claim, .tasks-section .btn-claim {\n        width: 100%; /* Set button width to fill container */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
